export default __webpack_public_path__ + "static/media/checkin.70c4d0ce.png";